function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Servi\\xE7os",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "servicos_video",
  transform: "translate(-248.000000, -242.000000)",
  fill: "#EA9C16",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(248.000000, 242.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,6 C14.5522847,6 15,6.44771525 15,7 C15,7.51283584 14.6139598,7.93550716 14.1166211,7.99327227 L14,8 L0,8 C-0.55228475,8 -1,7.55228475 -1,7 C-1,6.48716416 -0.61395981,6.06449284 -0.116621125,6.00672773 L0,6 L14,6 Z",
  id: "Line",
  transform: "translate(7.000000, 7.000000) rotate(45.000000) translate(-7.000000, -7.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,6 C14.5522847,6 15,6.44771525 15,7 C15,7.51283584 14.6139598,7.93550716 14.1166211,7.99327227 L14,8 L0,8 C-0.55228475,8 -1,7.55228475 -1,7 C-1,6.48716416 -0.61395981,6.06449284 -0.116621125,6.00672773 L0,6 L14,6 Z",
  id: "Line",
  transform: "translate(7.000000, 7.000000) scale(-1, 1) rotate(45.000000) translate(-7.000000, -7.000000) "
}))));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.d73048a0.svg";
export { ForwardRef as ReactComponent };